module.exports = __webpack_public_path__ + "static/media/bulb.5dbc62f5.svg";